// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"898bab36","98":"c721ba90","126":"4aed6aac","147":"c0838e8a","171":"91efa468","374":"c9d631a4","388":"799140e1","453":"afc244ec","528":"36de65f2","780":"e2ef7d88","857":"afc2a292","995":"f5c80eca"}[chunkId] + ".chunk.js";
};